import { EventAggregator } from 'aurelia-event-aggregator';
import {
	autoinject,
	bindable,
	bindingMode,
	computedFrom,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';

import { Field } from '~/components/field/common/field';
import { Form } from '~/components/form/form';
import { DateFormatValueConverter } from '~/converters/date-format';
import {
	commonFieldProperties,
	registerComponent,
} from '~/forms/customisation-editor/property-meta';
import { DataTypeEnum } from '~/models/data-type';
import { LocalizedDateTimeFormats } from '~/utils/datetime/localized-date-time-formats';

const componentTagName = 'a-text';

registerComponent(componentTagName, {
	name: 'Text',
	requirePath: PLATFORM.moduleName('components/field/common/text'),
	props: commonFieldProperties,
	isSelectable: true,
});

@autoinject
@customElement(componentTagName)
@useView(PLATFORM.moduleName('./text.html'))
export class TextField extends Field {
	/**
	 * If 'readonly' is true, setting this will cause the value to be wrapped in an anchor with this as the href.
	 */
	@bindable({ defaultBindingMode: bindingMode.oneWay })
	private anchorHref: string = '';

	constructor(
		public element: Element,
		protected parentForm: Form,
		readonly eventAggregator: EventAggregator,
	) {
		super(Field.TYPE.TEXT, element, parentForm, eventAggregator);
	}

	public attached() {
		super.attached();
	}

	/**
	 * Compute the display value.
	 * Used when the field is in non-edit mode.
	 */
	@computedFrom(
		'fieldModel',
		'fieldModel.dataType',
		'fieldModel.dataType.name',
		'value',
	)
	get displayValue() {
		if (this.fieldModel?.dataType?.name === DataTypeEnum.Timestamp) {
			return DateFormatValueConverter.toViewStatic(
				this.value,
				LocalizedDateTimeFormats.DateTime,
				true,
			);
		}
		return this.value;
	}
}
